<template>
    <div class="work">
        <div class="work-tab-top">
            <div class="work-tab__content-container">
                <h2 class="work-tab__content-heading" v-html=workOneTitle></h2>
                <h2 class="work-tab__content-heading-sub" v-html=workOneTitleSub></h2>

                <div class="work-tab__read-more-link-container">
                    <router-link class="work-tab__read-more-link" :to=workOneLink>Read More</router-link>
                </div>
            </div>

            <transition appear
                v-on:before-enter="beforeEnterImageTab"
                v-on:enter="enterImageTab">
                <div class="work-tab-top__image-container">
                    <img :src=workOneImage :alt=workOneImageAltText class="work-tab-top__image">
                </div>
            </transition>
        </div>

        <div class="work-tab-bottom">
            <div class="work-tab__content-container">
                <h2 class="work-tab__content-heading" v-html=workTwoTitle></h2>
                <h3 class="work-tab__content-heading-sub" v-html=workTwoTitleSub></h3>

                <div class="work-tab__read-more-link-container">
                    <router-link class="work-tab__read-more-link" :to=workTwoLink>Read More</router-link>
                </div>
            </div>

            <transition appear
                v-on:before-enter="beforeEnterImageTab"
                v-on:enter="enterImageTab">
                <div class="work-tab-bottom__image-container">
                    <img :src=workTwoImage :alt=workTwoImageAltText class="work-tab-bottom__image">
                </div>
            </transition>
        </div>

        <transition appear
                v-on:before-enter="beforeEnterWorkContent"
                v-on:enter="enterWorkContent">
            <div class="work-content__container">
                <h2 class="work-content__heading">WORK</h2>

                <ul class="work-content__page-counter-list">
                    <li class="work-content__page-counter-item">
                        <router-link class="work-content__page-counter-link active" to="/work"></router-link>
                    </li>

                    <li class="work-content__page-counter-item">
                        <router-link class="work-content__page-counter-link" to="/culture"></router-link>
                    </li>

                    <li class="work-content__page-counter-item">
                        <router-link class="work-content__page-counter-link" to="/expertise"></router-link>
                    </li>

                    <li class="work-content__page-counter-item">
                        <router-link class="work-content__page-counter-link" to="/news"></router-link>
                    </li>

                    <li class="work-content__page-counter-item">
                        <router-link class="work-content__page-counter-link" to="/contact"></router-link>
                    </li>
                </ul>

                <button class="work-content__cta" v-on:click="exploreClick">Explore</button>
            </div>
        </transition>

        <transition appear
                v-on:before-enter="beforeEnterSideNavLeft"
                v-on:enter="enterSideNavLeft">
            <div class="work-side-nav__container--left">
                <router-link class="work-side-nav__link" to="/">
                    <img class="work-side-nav__image" src="/assets/imgs/scroll-left.png" alt="">
                </router-link>
            </div>
        </transition>

        <transition appear
                v-on:before-enter="beforeEnterSideNavRight"
                v-on:enter="enterSideNavRight">
            <div class="work-side-nav__container--right">
                <router-link class="work-side-nav__link" to="/culture">
                    <h2 class="work-side-nav__heading">Culture</h2>

                    <ul class="work-side-nav__page-counter-list">
                        <li class="work-side-nav__page-counter-item"></li>

                        <li class="work-side-nav__page-counter-item active"></li>

                        <li class="work-side-nav__page-counter-item"></li>

                        <li class="work-side-nav__page-counter-item"></li>

                        <li class="work-side-nav__page-counter-item"></li>
                    </ul>
                </router-link>
            </div>
        </transition>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .work {
        background-color: #ffffff;
        color: #ffffff;
        height: 100vh;
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .work-content__container {
        left: 50%;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%) scale(0.1);
        transform-origin: center center;
        transition: all 0.8s ease;
        z-index: 20;

        &.transform-anim {
            transform: translate(-50%, -50%) scale(1);
        }

        .work-content__heading {
            color: #003a4a;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 96px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0 0 20px;
            text-transform: uppercase;

            @media @breakpoint__tablet--large {
                font-size: 60px;
            }

            @media @breakpoint__mobile--large {
                font-size: 40px;
                margin: 0 0 10px;
            }
        }

        .work-content__cta {
            background-color: #e40046;
            border: none;
            border-radius: 5px;
            color: #fff;
            cursor: pointer;
            display: inline-block;
            font-size: 16px;
            letter-spacing: 1px;
            padding: 10px 30px;
            text-decoration: none;
            z-index: 20;

            @media @breakpoint__tablet--small {
                font-size: 14px;
            }
        }

        .work-content__page-counter-list {
            margin: 0 0 25px;
            padding: 0;

            .work-content__page-counter-item {
                display: inline-block;
                margin: 0 8px;

                @media @breakpoint__mobile--large {
                    border-radius: 2px;
                    height: 8px;
                    margin: 0 5px;
                    width: 8px;
                }

                .work-content__page-counter-link {
                    background: #cccccd;
                    border-radius: 3px;
                    display: block;
                    height: 12px;
                    width: 12px;
                    z-index: 1;

                    @media @breakpoint__mobile--large {
                        border-radius: 2px;
                        height: 8px;
                        width: 8px;
                    }

                    &.active {
                        background: #e40046;
                    }
                }
            }
        }
    }

    .work-side-nav__link {
        display: block;
        text-decoration: none;
    }

    .work-side-nav__container {
        position: absolute;
        text-align: right;
        top: 52%;
        transform: translate(0, -50%);

        @media @breakpoint__mobile--large {
            top: 49%;
        }

        .work-side-nav__heading {
            color: #dfe6e8;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 28px;
            letter-spacing: 1.5px;
            line-height: 1;
            margin: 0;
            text-transform: uppercase;

            @media @breakpoint__tablet--small {
                font-size: 20px;
            }

            @media @breakpoint__mobile--large {
                font-size: 14px;
            }
        }

        .work-side-nav__page-counter-list {
            margin: 0;
            padding: 0;

            .work-side-nav__page-counter-item {
                background: #cccccd;
                border-radius: 3px;
                display: inline-block;
                height: 5px;
                margin: 0 3px;
                width: 5px;
                z-index: 1;

                @media @breakpoint__mobile--large {
                    height: 4px;
                    margin: 0 2px;
                    width: 4px;
                }

                &.active {
                    background: #e40046;
                }
            }
        }

        @media @breakpoint__mobile--large {
             display: none;
        }
    }

    .work-side-nav__container--left {
        .work-side-nav__container();
        left: 12px;
        text-align: left;

        @media @breakpoint__mobile--large {
            left: 8px;
        }

        .work-side-nav__image {
            display: block;
            margin-top: 8px;

            @media @breakpoint__mobile--large {
                width: 125px;
            }
        }
    }

    .work-side-nav__container--right {
        .work-side-nav__container();
        right: 12px;

        @media @breakpoint__mobile--large {
            right: 8px;
        }
    }
    
    .work-tab__content-container {
        position: absolute;
        top: 50%;
        left: 50%;
        opacity: 0;
        text-align: center;
        transform: translate(-50%, -30%);
        width: 80%;
        z-index: 100;

        .work-tab__content-heading {
            color: #fff;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 26px;
            letter-spacing: 1px;
            margin: 0 0 5px 0;
            text-transform: uppercase;

            @media @breakpoint__mobile--large {
                font-size: 14px;
            }
        }

        .work-tab__content-heading-sub {
            color: #e40046;
            font-size: 24px;
            font-weight: normal;
            letter-spacing: 1px;
            margin: 0 0 25px 0;

            @media @breakpoint__mobile--large {
                font-size: 14px;
                margin: 0 0 15px 0;
            }
        }

        .work-tab__read-more-link {
            border: 1px solid #ffffff;
            border-radius: 5px;
            color: #ffffff;
            cursor: pointer;
            display: inline-block;
            font-family: Flama, Arial, Helvetica, sans-serif;
            font-size: 18px;
            letter-spacing: 0.2px;
            line-height: 1;
            margin: 0;
            padding: 3px 6px 2px;
            text-decoration: none;
            text-transform: uppercase;
            transition: 0.5s all;

            @media @breakpoint__mobile--large {
                font-size: 12px;
                line-height: 1.4;
                padding: 0 5px 1px;
            }

            &:focus {
                outline: none;
            }

            &:hover {
                background: #ffffff;
                color: #003a4a;
            }
        }
    }

    .work-tab-top {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        background: url(/assets/imgs/tab-pattern-bg.png);
        border-radius: 0 0 150px 150px;
        max-height: 30%;
        left: 0;
        margin: 0 auto;
        max-width: 830px;
        overflow: hidden;
        position: absolute;
        right: 0;

        .work-tab-top__image-container {
            border-radius: 0 0 150px 150px;
            display: block;
            margin: 0 auto;
            max-width: 830px;
            overflow: hidden;
            position: relative;
            transform: translateX(0);
            z-index: 10;

            &:before {
                content: "";
                background-color: #003A4A;
                height: 100%;
                left: 0;
                opacity: 0;
                position: absolute;
                transition: 0.5s opacity;
                top: 0;
                width: 100%;
            }

            &.active {
                &:before {
                    opacity: 0.7;
                }
            }

            .work-tab-top__image {
                display: block;
                width: 100%;
            }

            @media @breakpoint__tablet--medium {
                border-radius: 0 0 100px 100px;
            }

            @media @breakpoint__mobile--large {
                border-radius: 0 0 50px 50px;
            }
        }

        @media @breakpoint__tablet--medium {
            border-radius: 0 0 100px 100px;
        }

        @media @breakpoint__mobile--large {
            border-radius: 0 0 50px 50px;
        }
    }

    .work-tab-bottom {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        background: url(/assets/imgs/tab-pattern-bg.png);
        border-radius: 150px 150px 0 0;
        bottom: 0;
        max-height: 30%;
        left: 0;
        margin: 0 auto;
        max-width: 830px;
        overflow: hidden;
        position: absolute;
        right: 0;

        .work-tab-bottom__image-container {
            border-radius: 150px 150px 0 0;
            display: block;
            margin: 0 auto;
            max-width: 830px;
            overflow: hidden;
            position: relative;
            z-index: 10;

            &:before {
                content: "";
                background-color: #003A4A;
                height: 100%;
                left: 0;
                opacity: 0;
                position: absolute;
                transition: 0.5s opacity;
                top: 0;
                width: 100%;
            }

            &.active {
                &:before {
                    opacity: 0.7;
                }
            }

            .work-tab-bottom__image {
                display: block;
                width: 100%;
            }

            @media @breakpoint__tablet--medium {
                border-radius: 100px 100px 0 0;
            }

            @media @breakpoint__mobile--large {
                border-radius: 50px 50px 0 0;
            }
        }

        @media @breakpoint__tablet--medium {
            border-radius: 100px 100px 0 0;
        }

        @media @breakpoint__mobile--large {
            border-radius: 50px 50px 0 0;
        }
    }
</style>

<script>
    export default {
        name: "Work",
        data: function()
        {
            return {
                workOneTitle : "",
                workOneTitleSub : "",
                workOneImage : "",
                workOneImageAltText : "",
                workOneLink : "",
                workTwoTitle : "",
                workTwoTitleSub : "",
                workTwoImage : "",
                workTwoImageAltText : "",
                workTwoLink : ""
            }
        },
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                    //console.log(vm.$router);
                    vm.initImages(vm.$parent.modelWorkGallery);
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.set(".header-nav-button", {className:"+=news-work"});
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            initImages : function(data)
            {
                this.workOneTitle = data[1].Title;
                this.workOneTitleSub = data[1].TitleSub;
                this.workOneImage = data[1].Image.Main;
                this.workOneImageAltText = data[1].Image.AltText;
                this.workOneLink = "/work/case-studies/" + data[1].Slug;

                this.workTwoTitle = data[0].Title;
                this.workTwoTitleSub = data[0].TitleSub;
                this.workTwoImage = data[0].Image.Main;
                this.workTwoImageAltText = data[0].Image.AltText;
                this.workTwoLink = "/work/case-studies/" + data[0].Slug;
            },
            beforeEnterImageTab : function(el)
            {
                TweenMax.set(el, {opacity: 0});
                if (this.$parent._data.animationDirection === "right")
                {
                    TweenMax.set(el, {transform: "translateX(-150%)", delay: 0.1});
                }
                else
                {
                    TweenMax.set(el, {transform: "translateX(150%)", delay: 0.1});
                }
            },
            enterImageTab : function(el, done)
            {
                TweenMax.set(el, {opacity: 1, delay: 0.4});
                TweenMax.to(el, 0.7, {transform: "translateX(0)", delay: 0.4, onComplete: done});
            },
            beforeEnterWorkContent : function(el)
            {
                el.style.opacity = 0;

                if (this.$parent._data.animationDirection === "right")
                {
                    el.style.left = "10%";
                }
                else 
                {
                    el.style.left = "90%";
                }

                el.querySelector(".work-content__cta").style.transform = "scale(0, 0)";
            },
            enterWorkContent : function(el, done)
            {
                TweenMax.to(el, 0.3, {left: "50%", opacity: 1, delay: 0.3});
                TweenMax.set(el, {className:"+=transform-anim", delay: 0.6});
                TweenMax.to(".work-content__cta", 0.8, {transform: "scale(1, 1)", delay: 1.2, ease: Back.easeOut.config(2)});
                TweenMax.set(".work-tab-top__image-container", {className:"+=active", delay: 1.5});
                TweenMax.set(".work-tab-bottom__image-container", {className:"+=active", delay: 1.5});
                TweenMax.to(".work-tab__content-container", 0.5, {opacity: 1, delay: 1.7, onComplete: done});
            },
            beforeEnterSideNavLeft :function(el)
            {
                el.style.opacity = 0;
                el.style.transform = "translateX(-110%)";
            },
            enterSideNavLeft : function(el, done)
            {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 1.3});
            },
            beforeEnterSideNavRight :function(el)
            {
                el.style.opacity = 0;
                el.style.transform = "translateX(110%)";
            },
            enterSideNavRight : function(el, done)
            {
                TweenMax.to(el, 0.5, {opacity: 1, transform : "translateX(0)", delay: 1.3});
            },
            exploreClick: function()
            {   
                TweenMax.to(document.querySelector(".work-content__container"), 0.3, {opacity: 0});
                TweenMax.to(document.querySelector(".work-tab-top"), 0.6, {transform: "translateY(-100%)", delay: 0.2, ease: Power4.easeIn});
                TweenMax.to(document.querySelector(".work-tab-bottom"), 0.6, {transform: "translateY(100%)", delay: 0.2, ease: Power4.easeIn});

                var vm = this;
                setTimeout(function() {vm.goToExplore()}, 1000);
            },
            goToExplore: function()
            {
                this.$router.push("/work/case-studies");
            }
        }
    };
</script>
